export default __webpack_public_path__ + "static/media/deckPic.74b8f210.jpg";